import { Injectable } from "@angular/core";
import { ArrayHelper, Tools } from "@comunicare/comunicare-helper";
import { IDataSourceBackendParam, IFilter, IStatEvent, IStatEventView, IStatSummary } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { BaseApiService } from "./baseApi.service";

@Injectable({
  providedIn: "root",
})
export class UserStatisticsApiService extends BaseApiService {
  constructor(private api: ApiService, private translateService: TranslateService) {
    super(
      "UserStatistics", // Theme !
      [], // Post route paths
      ["dashboard/statisticSummary", "dashboard/statEvents", "dashboard/exportStatEvents", "dashboard/statEvents/private"], // Get route paths
      [], // Put route paths
      [] // Delete route paths
    );
  }

  public listSummaries(from: string, to: string): Observable<IStatSummary[]> {
    return this.api.get(this.readRoutes[0], { from, to }) as Observable<IStatSummary[]>;
  }

  public listStatEvents(p: IDataSourceBackendParam, services?: string[], includePrivateLogs = false): Observable<IStatEventView[]> {
    const copyParams = Tools.deepCopy(p);
    const params: any = {
      pageNumber: copyParams.pageNumber,
      pageSize: copyParams.pageSize,
      sortOrder: copyParams.sortOrder,
      lang: copyParams.lang ? copyParams.lang : this.translateService.currentLang,
      services: services?.join(","),
    };
    if (Tools.isDefined(copyParams.filters) && !ArrayHelper.isEmpty(copyParams.filters)) {
      const sourceFilter = copyParams.filters.find((f) => f.propertyName === "eventSource");
      if (sourceFilter) {
        sourceFilter.data = { value: sourceFilter.data.filter((d) => d.checked).map((d) => d.value) };
      }
      params.filters = JSON.stringify(copyParams.filters);
    }
    if (Tools.isDefined(copyParams.sortId)) {
      params.sortId = copyParams.sortId;
    }
    return this.api.get(includePrivateLogs ? this.readRoutes[3] : this.readRoutes[1], params) as Observable<IStatEventView[]>;
  }

  public countStatEvents(filters?: IFilter[], lang?: string, services?: string[], includePrivateLogs = false): Observable<number> {
    const copyFilters = Tools.deepCopy(filters);
    const params: any = {
      lang: lang ? lang : this.translateService.currentLang,
      services: services?.join(","),
    };
    if (Tools.isDefined(copyFilters) && !ArrayHelper.isEmpty(copyFilters)) {
      const sourceFilter = copyFilters.find((f) => f.propertyName === "eventSource");
      if (sourceFilter) {
        sourceFilter.data = { value: sourceFilter.data.filter((d) => d.checked).map((d) => d.value) };
      }
      params.filters = JSON.stringify(copyFilters);
    }
    return this.api.get("dashboard/countStatEvents" + (includePrivateLogs ? "/private" : ""), params) as Observable<number>;
  }

  public updateStatSummary(statToIncrement: string): Observable<IStatSummary> {
    return this.api.put("dashboard/statisticSummary", { statName: statToIncrement }) as Observable<IStatSummary>;
  }

  public createStatEvent(
    eventDescription: string,
    servicesIds?: string[],
    careplansIds?: string[],
    isPrivateLog?: boolean
  ): Observable<IStatEvent> {
    const body: any = {
      eventDescription,
      isPrivateLog,
    };
    if (Tools.isDefined(servicesIds) && !ArrayHelper.isEmpty(servicesIds)) {
      body.servicesIds = servicesIds.join(",");
    }
    if (Tools.isDefined(careplansIds) && !ArrayHelper.isEmpty(careplansIds)) {
      body.careplansIds = careplansIds.join(",");
    }
    return this.api.post("dashboard/statEvent", body) as Observable<IStatEvent>;
  }
}
